module.exports = __webpack_public_path__ + "img/the-netherlands-tuberculosis-male.7ea5fb20.png";